import { useCallback, useEffect, useState } from 'react'
import useAuthenticatedFetch from '../../hooks/useAuthenticatedFetch';
import { InlineGrid, MediaCard, Page } from '@shopify/polaris'
import './style.css'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
const OurMoreApps = props => {
    const [apps, setApps] = useState([])
    const fetchJson = useAuthenticatedFetch()
    const { path } = useParams()
    const { ConfigReducer } = useSelector(state => state)
    const { store } = ConfigReducer
    const getApps = useCallback(
        async () => {
            try {
                const apps = await fetchJson(`/applist?path=${path ? path : ""}&shop=${store?.domain}`, {
                    method: 'GET'
                })
                setApps(apps)
            } catch (e) {
                console.log(e.message);
            }
        },
        [fetchJson, path, store?.domain],
    )

    useEffect(() => {
        getApps()
    }, [])


    return (
        <Page title='Our more apps'>
            <div className='more-apps'>
                <InlineGrid columns={3} gap={300}>
                    {apps.length ? apps.map(app => {
                        return <MediaCard
                            portrait
                            title={app.name}
                            description={app.description}
                            primaryAction={{
                                content: "Install",
                                url: app.link,
                                external: true
                            }}
                        >
                            <img
                                alt=""
                                width="100%"
                                height="100%"
                                style={{
                                    objectFit: 'cover',
                                    objectPosition: 'center',
                                }}
                                src={app.image}
                            />
                        </MediaCard>
                    }) : null}
                </InlineGrid>
            </div>
        </Page>
    )
}

export default OurMoreApps



